const en = {
  i18nView: {
    account: 'Account',
    balance: 'Balance',
    fund: 'Fund',
    login: 'Login',
    logout: 'Logout',
    previousPage: 'Previous',
    index: 'Index',
    nextPage: 'Next',
    personalInfo: 'Profile',
    rexFundTips: 'Trading REX and leasing resources require transferring ',
    rexFundTips1: ' from the balance to the REX fund in advance, using ',
    rexFundTips2: ' in REX fund to trade REX and resource leasing. ',
    iknow: 'I know',
    amount: 'Amount',
    overview: 'Overview',
    totalRex: 'REX Total',
    totalEos: 'Total',
    lendable: 'Lendable',
    lent: 'Lent',
    rentCost: 'Rent Income',
    lentPercent: 'Lent Percent',
    deposit: 'Deposit REX Fund',
    withdraw: 'Withdraw REX Fund',
    rexPriceTrend: 'REX Price',
    rexTrading: 'REX Trade',
    buyRex: 'Buy REX',
    sellRex: 'Sell REX',
    availableRex: 'Available',
    unstakeToRex: 'Unstaked to REX',
    stakedAccount: 'Staked Account',
    unstake: 'Unstake',
    day: 'Days',
    resourceFund: 'Resource Fund',
    myRexHistory: 'My REX History',
    resPrice: 'Resource Rates',
    resBorrow: 'Borrow CPU / NET ',
    currentPrice: 'Lastest Rates',
    resType: 'Resource Type',
    resReceiver: 'Recipient',
    payment: 'Payment',
    borrow: 'Borrow',
    orders: 'Orders',
    dueTime: 'Due Time',
    stakeList: 'Staked List',
    unstakeTips: 'You can unstake resource changing to REX directly, without waiting for 3 days',
    viewRestRex: 'View REX maturities',
    maturityTime: 'Maturity Time',
    noStakeRecord: 'No stake record',
    rexMaturity: 'REX Maturity',
    voteTips: 'To buy REX, you need to vote for at least 21 producers or a proxy. But you can buy REX directly here. If you do not meet the requirements, we will vote by default to our proxy ',
    success: 'Success!',
    you: 'You',
    unstakeToRexTips: 'Please unstake according to the usage of resources. Excessive unstake may fail.',
    postiveAmount: 'Please choose at least one resource for unstake',
    resourceFundTips: '*Resource fund can renew your order after 30 days. It\'s optional, and you can deposit or withdraw fund during the order.',
    fundText: 'Deposit Fund',
    unfundText: 'Withdraw Fund',
    depositRes: 'Deposit',
    withdrawRes: 'Withdraw',
    willGet: 'Will get ',
    waitingForDeploy: 'Something is wrong with the contract',
    switchto: 'Switch to',
    rexValue: 'Equivalent',
    resTips: '*Borrow resources will consume your tokens. Please do not use them until you understand that.',
    ramIncome: 'RAM fee income',
    bidnameIncome: 'Bidname income',
    apr: 'Estimated APR',
    manageRexSavings: 'Manage REX savings',
    rexSavings: 'REX Savings',
    savingTips: 'For accounts looking to hold their A in REX for a long time, we have the ability to lock away REX within REX Savings. The amount locked away (staked) will not mature but wait for your unstake action which will then require about 5 days to mature. ',
    staked: 'Staked(Savings)',
    stakeable: 'Able to Stake',
    stakeRex: 'Stake REX',
    unstakeRex: 'Unstake REX',
    rentPrice: 'Resource Price',
    totalRentNumber: 'Number of loans',
    myRexInQueue: 'My REX in sell queue',
    currentRexQueue: 'Orders in sell queue',
    cancelRexQueue: 'Cancel Sell',
    updateRexStatus: 'Update Status',
    queueing: 'Actual',
    myQueueIndex: 'Queue Index',
    loanStatus: 'Recently expired loan order',
    availableEosPercent: 'Available ',
    viewExpiredOrder: 'View expired loan order',
    helpCleanOrder: '❤ Help clean expired orders',
    refresh: 'Refresh',
    sellRexOrder: 'Orders in REX sell queue',
    borrowInvilidTip: '*Borrow resource is not allowed until sell orders are filled and `Lendable` / `Lent ` > 20% .',
    applyTime: 'Submit Time',
    expiredTime: 'Expire Time'
  }
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js